import { Auth } from '../services/auth.service';

export const getStoredDynToken = async () => {
  const token = Auth.getDynJwtToken();
  Auth.saveMSALToken(token);

  return token;
};
